export class Contact {
    constructor() {
        this.extras = {};
    }
}
export var Gender;
(function (Gender) {
    Gender["Male"] = "male";
    Gender["Female"] = "female";
})(Gender || (Gender = {}));
export class MergeContactActionSettings extends Contact {
    constructor() {
        super();
    }
}
